<template>
  <gg-card>
    <gg-card-text class="pa-3">
      <h2 class="kvm-ip__title body-1 d-flex align-center mb-3">
        <v-icon size="24" color="primary" class="mr-2" aria-hidden="true">mdi-ip-network</v-icon>
        IP Addresses
      </h2>

      <div class="kvm-ip__table">
        <v-simple-table>
          <template v-slot:default>
            <caption class="kvm-ip__caption">IP addresses assigned to this server</caption>
            <thead>
              <tr>
                <th scope="col" class="text-left">IP Address</th>
                <th scope="col" class="text-left">Type</th>
                <th scope="col" class="text-left">Assignment</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ip, i) in ipList" :key="ip">
                <td data-label="IP Address"><kvm-copyable :value="ip" /></td>
                <td data-label="Type">IPv4</td>
                <td data-label="Assignment">{{ i === 0 ? 'Primary' : 'Additional' }}</td>
              </tr>
              <tr v-if="!ipList.length">
                <td colspan="3" class="text-center kvm-ip__empty">No IP addresses assigned yet.</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <!-- Requesting additional IPs has no backend yet — honest disabled state
           instead of a button that only fired a fake success toast. -->
      <div class="kvm-ip__request mt-4">
        <gg-btn small tile color="primary" disabled aria-describedby="kvm-ip-request-note">
          <v-icon left small aria-hidden="true">mdi-plus</v-icon>Request IP
        </gg-btn>
        <p id="kvm-ip-request-note" class="kvm-ip__note mt-2 mb-0">
          Requesting additional IP addresses isn't available yet.
        </p>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
import KvmCopyable from '@/views/services/hosting/kvm/KvmCopyable'

export default {
  name: 'HostingKvmIp',
  components: { KvmCopyable },
  props: {
    server: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  computed: {
    ipList () { return this.server.ips || [] },
  },
}
</script>

<style scoped lang="scss">
@import './kvm-ui';

.kvm-ip__title {
  margin: 0;
  font-weight: 400;
}

// Real IP table: neutralise the off-brand teal dark stripe and reflow to stacked
// cards on narrow screens (no clipped horizontal scroll at 320px).
.kvm-ip__table {
  @include kvm-table-destripe;
  @include kvm-stacked-table;
}

// Accessible name for the table; visually hidden (the h2 above is the visible label).
.kvm-ip__caption {
  @include kvm-sr-only;
}

.kvm-ip__empty {
  @include kvm-secondary-text;
}

.kvm-ip__note {
  @include kvm-secondary-text;
  font-size: 0.8125rem;
}
</style>
